import { AppPasswordInput, Button } from "components";
import AuthLayout from "layouts/AuthLayout";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useSearchParams } from "react-router-dom";
import { ApiService } from "services";
import { Router } from "utils/route";

export default function Login() {
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [loader, setLoader] = useState(false);
  const { route } = Router();

  const [param] = useSearchParams();
  const activeTab = param.get("otp");

  const loginAdmin = async () => {
    if (password && confirmPassword && password === confirmPassword) {
      setLoader(true);
      try {
        const data = await ApiService.forgotPassword({
          slug: activeTab,
          password: password,
          confirmPassword: confirmPassword,
        });
        console.log(data);
        setLoader(false);
        route("/");
        toast.success(data?.message);
      } catch (err) {
        console.log(err);
        setLoader(false);
        if (err?.message === "It's not you, it's us. Try again later.") {
        } else if (err?.message === "Network Error") {
          return;
        } else {
          toast.error(err?.response?.data?.message || err?.message);
        }
      }
    } else {
      toast.error("Passwords must match");
    }
  };
  return (
    <div>
      <AuthLayout
        submit={(e) => {
          e.preventDefault();
          console.log("eeee");
          loginAdmin();
        }}
        title="Set New Password"
      >
        <AppPasswordInput
          onChange={(e) => {
            setPassword(e.target.value);
          }}
          placeholder="Password"
        />
        <AppPasswordInput
          onChange={(e) => {
            setConfirmPassword(e.target.value);
          }}
          placeholder="Confirm Password"
        />
        <Button loading={loader} disabled={loader} placeholder="Proceed" />
      </AuthLayout>
    </div>
  );
}
